import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Button, Form, Col, Row } from 'react-bootstrap';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import LayoutFullpage from 'layout/LayoutFullpage';
import Countdown from 'react-countdown';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
import HtmlHead from 'components/html-head/HtmlHead';
import { observer } from 'mobx-react';
import { GetUserRegistrationStore } from 'SessionState/Registration/UserRegistrationStore';
import { useHistory } from 'react-router-dom';

const UpgradeDirectorMembership = (observer(() => {

  return (
    <>
     <div className="min-h-100 bg-foreground d-flex justify-content-center align-items-center shadow-deep py-5 full-page-content-right-border">
      <div className="sw-lg-60 px-5">
        <div className="sh-11  d-flex justify-content-center">
          <NavLink to="/">
            <div className="logo-default theme-filter " />
          </NavLink>
        </div>
        <div className="mb-3">
          <h2 className="cta-1 mb-0 text-primary">This feature is not available with a Mini Director Membership</h2>
        </div>
        <div className="mb-3">
          <p className="h6 lh-1-5">
To get all our event management features, we invite you to try out Grand Director Membership!
          </p>
        </div>

        <div>
        <div className="mb-3  d-flex justify-content-center">
        <Button href="https://billing.stripe.com/p/login/3csbKWf4ndtj1TWcMM" className="btn-icon btn-icon-end">
              <span>Upgrade Now!</span>
              <CsLineIcons icon="chevron-right" />
            </Button>
        </div>
         
        </div>
        <div className="mb-5">
          <p className="h6">
          If you have any questions, please <NavLink to="/contact">Contact Us!</NavLink>.
          </p>
        </div>
      </div>
    </div>
    </>
  );
})
)

export default UpgradeDirectorMembership;
